<div class="container padding--none">
  <div class="content">
    <div class="container" [class.spec-differences]="hasSpecDifferences">
      <div class="container__header">
        <h2 (click)="onClose()">
          <span class="link typog-button">Compare models</span>
          <i class="fa-solid fa-chevron-down typog-button ml-2"></i>
        </h2>
        <h3 *ngIf="hasSpecDifferences">
          These products have different specifications. See the table below for
          more details.
        </h3>
      </div>

      <button
        type="button"
        class="close-card typog-body-large"
        aria-label="Close"
        (click)="onClose()"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>
